import React from 'react';
import DatePicker from 'react-datepicker';
import { useTranslation } from 'react-i18next';

import "react-datepicker/dist/react-datepicker.css";

export default function DateRangeModal({ value, onChange, onClose }) {
  const { t } = useTranslation();
  const [startDate, setStartDate] = React.useState(value?.startDate ? new Date(value.startDate) : null);
  const [endDate, setEndDate] = React.useState(value?.endDate ? new Date(value.endDate) : null);

  const handleApply = () => {
    onChange({
      startDate: startDate.toISOString().split('T')[0],
      endDate: endDate.toISOString().split('T')[0]
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 dark:bg-gray-800" onClick={e => e.stopPropagation()}>
        <h3 className="text-lg font-semibold mb-4 dark:text-white">{t('Select Date Range')}</h3>

        <div className="grid grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">{t('Start Date')}</label>
            <DatePicker
              selected={startDate}
              onChange={date => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              maxDate={endDate || new Date()}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm dark:bg-gray-800 dark:text-white"
              dateFormat="yyyy-MM-dd"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">{t('End Date')}</label>
            <DatePicker
              selected={endDate}
              onChange={date => setEndDate(date)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              maxDate={new Date()}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm dark:bg-gray-800 dark:text-white"
              dateFormat="yyyy-MM-dd"
            />
          </div>
        </div>

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
          >
            {t('Cancel')}
          </button>
          <button
            onClick={handleApply}
            disabled={!startDate || !endDate}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-blue-300"
          >
            {t('Apply')}
          </button>
        </div>
      </div>
    </div>
  );
}